export * from './mandant-config.service';
